import React from 'react';
import http from '../api';
import PopupFrameV2 from '../popup/PopupFrameV2';
import Button from './Button';

export class ShopGptAnalisysCompletePopup extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
        }
    }

    componentWillMount() {
    }

	componentDidMount() {
    
    }

    componentDidUpdate() {
    
    }

    componentWillUnmount(e) {
    
    }

    render() {
        return (
            <div>
                <div className="ShopGptAnalisysCompletePopup" style={{position:"fixed", zIndex: 99999}}>
                    <PopupFrameV2
                            className={"ShopGptAnalisysCompletePopupFrame"}
                            width={"auto"}
                            maxWidth={"90vw"}
                            // height={"90vh"}
                            maxHeight={"90vh"}
                            padding={"40px 0px 0px 0px"}
                            onClose={() => {
                                this.props.onClose(); // 상위에서 showFirstIntroPopup=false 처리
                            }}
                        >
                        <div className="flexBox" style={{flexDirection:'column', flexWrap:"nowrap", height:"100%", textAlign:"center", alignItems: "center"}}>
                            <div className="flexBox" style={{flex:"1", flexDirection:'column', flexWrap:"nowrap", textAlign:"center", alignItems: "center", padding:"0px 40px 50px 40px"}}>
                                <div style={{display:"flex", alignItems: "center"}}>
                                    <img className="logo" src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/0e962a7a54a126f4e37dde4810da9e4f7ad6f91e.png" style={{width:"100px", height:"auto"}}/>
                                    <div style={{display: "flex", alignItems: "center", marginLeft: "10px"}}>
                                        <div className="title" style={{fontWeight: "700", fontSize: "20px", fontFamily:"Roboto Flex", marginRight:"80px"}}>
                                            쇼핑몰분석이 완료되었어요<br/>
                                            너무 기대되시죠?<br/>
                                            (어떤 정보가 있을까요?)
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='flexBox' style={{width: "100%", justifyContent: "center", height:"auto"}}>
                                <div id="button" onClick={() => {
                                    this.props.onClose(); // 상위에서 showFirstIntroPopup=false 처리
                                }}>{
                                    "예"
                                }</div>
                            </div>
                        </div>
                    </PopupFrameV2>
                </div>
            </div>
        )
    };
}